export const CHART_PRICE_STOCK_EVOLUTION_COLORS = [
	"#26aaff",
	"#fdba36",
	"#a161fe",
	"#f571f0",
	"#45b9d9",
	"#e76f3e",
	"#9f42a3",
	"#5bc8a0",
	"#ff7f00",
	"#4c4c4c",
	"#d1a82c",
	"#007b5f",
	"#ff9aa2",
	"#6a67ce",
	"#c259b6",
	"#3eaf76",
	"#ffaa4c",
	"#0087bd"
]

export const CHART_PRICE_STOCK_STATUS_COLOR = {
    IN_STOCK: '#54d62c',
    OUT_OF_STOCK: '#ff0000'
}